var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2362 1.57207C9.4664 1.34186 9.83964 1.34186 10.0698 1.57207L12.4277 3.92996C12.6579 4.16017 12.6579 4.5334 12.4277 4.7636L4.76458 12.4268C4.65403 12.5373 4.5041 12.5994 4.34776 12.5994H1.98986C1.66431 12.5994 1.40039 12.3355 1.40039 12.0099V9.65204C1.40039 9.49571 1.4625 9.34577 1.57304 9.23522L9.2362 1.57207ZM2.57934 9.89621V11.4205H4.10359L11.1773 4.34678L9.65302 2.82253L2.57934 9.89621Z",
    fill: "#414143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46778 3.34049C7.69798 3.11028 8.07122 3.11028 8.30142 3.34049L10.6593 5.69838C10.8895 5.92859 10.8895 6.30182 10.6593 6.53202C10.4291 6.76223 10.0559 6.76223 9.82567 6.53202L7.46778 4.17413C7.23758 3.94393 7.23758 3.57069 7.46778 3.34049Z",
    fill: "#414143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEditIcon);
export default __webpack_public_path__ + "static/media/new-edit-icon.fa6848ac67d4a4f0de1070068c26f06b.svg";
export { ForwardRef as ReactComponent };